import { UIGameMapTileView } from './UIGameMapTileView.ts';
import { PIXI } from '@colonist/pixi';
import { logError } from '../../ui_utils/Utils.ts';
import { ArrayUtils } from '@colonist/utils';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { TileHexType } from '@colonist/game-states';
export class UIGameBaseShoreTileController {
    createShoreTile(tile, texture, angle = 0) {
        const mapView = this.uiGameManager.mapController.mapView;
        const tileCenter = tile.toPixel(mapView.mapCenter, mapView.hexagonHeight / 2);
        const w = mapView.hexagonWidth;
        const h = mapView.hexagonHeight;
        const tileView = new UIGameMapTileView(this.uiGameManager, tile, tileCenter.x - w / 2, tileCenter.y - h / 2, w, h, texture, mapView);
        tileView.eventMode = 'none';
        tileView.tileSpriteView.rotate(angle);
        this.shoreTiles.push(tileView);
        return tileView;
    }
    getTextureAndAngle(hexFace) {
        const pattern = this.getShorePatternFromHexFace(hexFace);
        const numberOfShoreEdgesAroundHexFace = pattern.filter(Boolean).length;
        switch(numberOfShoreEdgesAroundHexFace){
            case 0:
                return {
                    texture: PIXI.Texture.EMPTY,
                    angle: 0
                };
            case 1:
                const patternFit = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    false,
                    false,
                    false,
                    false,
                    false
                ]);
                if (patternFit.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_1),
                    angle: patternFit.angle
                };
                break;
            case 2:
                let patternFit2 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    true,
                    false,
                    false,
                    false,
                    false
                ]);
                if (patternFit2.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_2_sswwww),
                    angle: patternFit2.angle
                };
                patternFit2 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    false,
                    true,
                    false,
                    false,
                    false
                ]);
                if (patternFit2.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_2_swswww),
                    angle: patternFit2.angle
                };
                patternFit2 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    false,
                    false,
                    true,
                    false,
                    false
                ]);
                if (patternFit2.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_2_swwsww),
                    angle: patternFit2.angle
                };
                break;
            case 3:
                let patternFit3 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    true,
                    true,
                    false,
                    false,
                    false
                ]);
                if (patternFit3.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_3_ssswww),
                    angle: patternFit3.angle
                };
                patternFit3 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    true,
                    false,
                    false,
                    true,
                    false
                ]);
                if (patternFit3.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_3_sswwsw),
                    angle: patternFit3.angle
                };
                patternFit3 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    true,
                    false,
                    true,
                    false,
                    false
                ]);
                if (patternFit3.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_3_sswsww),
                    angle: patternFit3.angle
                };
                patternFit3 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    false,
                    true,
                    false,
                    true,
                    false
                ]);
                if (patternFit3.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_3_swswsw),
                    angle: patternFit3.angle
                };
                break;
            case 4:
                let patternFit4 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    true,
                    true,
                    true,
                    false,
                    false
                ]);
                if (patternFit4.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_4_ssssww),
                    angle: patternFit4.angle
                };
                patternFit4 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    true,
                    true,
                    false,
                    true,
                    false
                ]);
                if (patternFit4.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_4_ssswsw),
                    angle: patternFit4.angle
                };
                patternFit4 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    true,
                    false,
                    true,
                    true,
                    false
                ]);
                if (patternFit4.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_4_sswssw),
                    angle: patternFit4.angle
                };
                break;
            case 5:
                const patternFit5 = UIGameBaseShoreTileController.getShorePatternFit(pattern, [
                    true,
                    true,
                    true,
                    true,
                    true,
                    false
                ]);
                if (patternFit5.fits) return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_5),
                    angle: patternFit5.angle
                };
                break;
            case 6:
                return {
                    texture: UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.tile_shore_6),
                    angle: 0
                };
        }
        logError('getTextureAndAngle', [
            numberOfShoreEdgesAroundHexFace
        ]);
        return {
            texture: UIGameSpriteHandler.getHexImage(TileHexType.Sea),
            angle: 0
        };
    }
    getShorePatternFromHexFace(hexFace) {
        const pattern = [];
        for (const hexEdge of hexFace.edges()){
            pattern.push(this.uiGameManager.gameController.mapValidator.tileState.isEdgeOnShore(hexEdge));
        }
        return pattern;
    }
    static getShorePatternFit(tilePattern, givenPattern) {
        const newGivenPattern = givenPattern;
        for(let i = 0; i < 6; i += 1){
            if (ArrayUtils.arraysEqual(tilePattern, newGivenPattern)) return {
                fits: true,
                angle: i * 60
            };
            const popElement = newGivenPattern.pop();
            if (popElement == undefined) continue;
            newGivenPattern.unshift(popElement);
        }
        return {
            fits: false,
            angle: 0
        };
    }
    constructor(uiGameManager){
        this.shoreTiles = [];
        this.uiGameManager = uiGameManager;
    }
}
